module.exports = __webpack_public_path__ + "img/bottom_icon01.b661222.png";